import React, { FunctionComponent } from 'react';
import { useInView } from 'react-intersection-observer';
import { Button } from '@justgiving/react-tracking';

import FacebookShare from '../SocialButtons/FacebookShare';
import TeamSummary from '../TeamSummary/TeamSummary';
import styles from './TeamCTA.scss';
import isDesktopViewport from '../../utils/isDesktopViewport';

export type TeamCTAProps = {
  membersListRef: React.RefObject<HTMLElement>;
};

const TeamCTA: FunctionComponent<TeamCTAProps> = props => {
  const [ref, inView] = useInView();
  const { membersListRef } = props;

  function scrollToMembersList() {
    if (!membersListRef.current) return;

    let offsetTop = membersListRef.current!.offsetTop;

    // 72 less due to the height of the sticky header on desktop
    if (isDesktopViewport()) offsetTop -= 72;

    window.scrollTo(0, offsetTop);

    membersListRef.current.querySelector('h1')!.focus({ preventScroll: true });
  }

  return (
    <>
      <div ref={ref} className={styles.ctaWrapper}>
        <Button
          type="button"
          data-qa="donate-scroll-btn"
          className={`jg-btn jg-btn--themed ${styles.donateBtn}`}
          onClick={scrollToMembersList}
          trackingData={{
            event_label: 'Donate to a team member',
            page_section: 'top',
            event: 'link click',
            action_name: 'link click',
            event_value: 'donate scroll to members list',
            subtype: 'button',
          }}
        >
          Donate to a team member
        </Button>

        <FacebookShare trackingData={{ sub_section: 'top' }} showPrefix />
        <TeamSummary showSummary={!inView} />
      </div>
    </>
  );
};

export default TeamCTA;
